import { env } from "@/env";

function normalizedFlag(value: string | undefined): string {
  return (value ?? "").trim().toLowerCase();
}

function enabledUnlessExplicitOff(value: string | undefined): boolean {
  const flag = normalizedFlag(value);
  return flag !== "0" && flag !== "false";
}

function enabledWhenExplicitOn(value: string | undefined): boolean {
  const flag = normalizedFlag(value);
  return flag === "1" || flag === "true";
}

function enabledWhenAffirmative(value: string | undefined): boolean {
  return enabledWhenExplicitOn(value) || normalizedFlag(value) === "yes";
}

function currentPublicEnv(key: keyof typeof env): string | undefined {
  return process.env[key] ?? env[key];
}

export const CHAT_STREAMING_ENABLED = enabledUnlessExplicitOff(
  env.NEXT_PUBLIC_CHAT_STREAMING_ENABLED
);
export function isChatStreamingEnabled(): boolean {
  return enabledUnlessExplicitOff(currentPublicEnv("NEXT_PUBLIC_CHAT_STREAMING_ENABLED"));
}

export const CHAT_OFFER_MOMENT_ENABLED = enabledWhenExplicitOn(
  env.NEXT_PUBLIC_CHAT_OFFER_MOMENT_ENABLED
);
export function isChatOfferMomentEnabled(): boolean {
  return enabledWhenExplicitOn(currentPublicEnv("NEXT_PUBLIC_CHAT_OFFER_MOMENT_ENABLED"));
}

export const MEMBERSHIP_ENABLED = enabledWhenAffirmative(env.NEXT_PUBLIC_MEMBERSHIP_ENABLED);
export function isMembershipEnabled(): boolean {
  return enabledWhenAffirmative(currentPublicEnv("NEXT_PUBLIC_MEMBERSHIP_ENABLED"));
}

// SEO-surface free web-push capture (2026-07-21). BORN DARK — only an explicit
// "1"/"true" enables it, so the anonymous SEO landing pages render nothing until
// the daily-loop D7 retention gate proves out (~07-23+, owner decision).
export const SEO_SURFACE_PUSH_CAPTURE_ENABLED = enabledWhenExplicitOn(
  env.NEXT_PUBLIC_SEO_SURFACE_PUSH_CAPTURE_ENABLED
);
export function isSeoSurfacePushCaptureEnabled(): boolean {
  return enabledWhenExplicitOn(currentPublicEnv("NEXT_PUBLIC_SEO_SURFACE_PUSH_CAPTURE_ENABLED"));
}
